import React from 'react';
import { BoltIcon, CheckIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { included } from '../data/content';
import { CHECKOUT_URL } from '../data/constants';
import { CTAButton } from './CTAButton';
export function Offer() {
  return <section id="offre" className="scroll-mt-4 bg-cream px-4 py-9 sm:px-6 sm:py-12" data-id="element-151" data-mp="1mmqx21lulfnn">
      <div className="mx-auto max-w-4xl text-center" data-id="element-152" data-mp="1hoxste43uvq0">
        <h2 className="text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-153" data-mp="tyblxq5u7hhl">
          Tout est inclus. Un seul prix.
        </h2>
        <p className="mt-1 text-[13px] text-graphite/75 sm:text-sm" data-id="element-154" data-mp="p0tk0jq8m2j3">
          Aucun abonnement. Aucun frais caché.
        </p>

        <div className="mt-5 overflow-hidden rounded-2xl border-2 border-petrol bg-white text-left shadow-xl" data-id="element-155" data-mp="13yc6fffg03nd">
          <div className="bg-petrol px-4 py-3.5 text-center sm:px-6" data-id="element-156" data-mp="z0arn6p1uqhp">
            <h3 className="text-base font-extrabold text-white sm:text-xl" data-id="element-157" data-mp="2famuj8j8rblh">
              Orthophonie Pro™ — Système complet
            </h3>
            <p className="mt-0.5 text-[12px] text-cream/80 sm:text-sm" data-id="element-158" data-mp="pk7fjklocj8x">
              1 Système Principal Avec 6 Modules + 5 Bonus Stratégiques
            </p>
          </div>

          <div className="grid gap-5 p-4 sm:grid-cols-5 sm:p-6" data-id="element-159" data-mp="ulemjhfzteej">
            <div className="sm:col-span-3" data-id="element-160" data-mp="zjpxjvi0xuyc">
              <p className="font-display text-[10px] font-bold uppercase tracking-[0.16em] text-sage-dark" data-id="element-161" data-mp="zgka0kp1n14q">
                Ce qui est inclus
              </p>
              <ul className="mt-2 space-y-1.5" data-id="element-162" data-mp="6v0wfwgyxpml">
                {included.map(item => <li key={item} className="flex gap-2 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-163" data-mp="btlupqcntz8e">
                    <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-petrol" data-id="element-164" data-mp="ftmapffeqihk" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center rounded-xl bg-cream-dark p-4 text-center sm:col-span-2" data-id="element-165" data-mp="3k847u6hgk4yv">
              <p className="text-xs font-semibold text-graphite/60 line-through" data-id="element-166" data-mp="3o7ut5uo7tsw0">
                Prix Régulier : 97 €
              </p>
              <p className="font-display text-5xl font-extrabold leading-none text-petrol sm:text-6xl" data-id="element-167" data-mp="qhfn7rcq129z">
                27 €
              </p>
              <p className="mt-1.5 rounded-full bg-gold px-2.5 py-1 font-display text-[10px] font-extrabold uppercase tracking-widest text-petrol-dark" data-id="element-168" data-mp="154qw1lhiq86e">
                Économisez 70 €
              </p>
              <p className="mt-2 font-display text-[10px] font-bold uppercase tracking-widest text-petrol" data-id="element-169" data-mp="ch4s2c4dp1j0">
                Paiement unique · Accès à vie
              </p>
            </div>
          </div>

          <div className="px-4 pb-5 sm:px-6" data-id="element-170" data-mp="lfgjuhgze5d1">
            <CTAButton href={CHECKOUT_URL} className="mx-auto max-w-lg" data-id="element-171" data-mp="hfpvsliua3c7">
              Accédez à Orthophonie Pro™ maintenant
            </CTAButton>
            <p className="mt-2 text-center text-[11px] text-graphite/70 sm:text-xs" data-id="element-172" data-mp="1wyt1ibbf1wu5">
              Protégé par notre garantie satisfait ou remboursé de 7 jours.
            </p>
            <ul className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-graphite/70" data-id="element-173" data-mp="20d2makcu3vow">
              <li className="flex items-center gap-1.5" data-id="element-174" data-mp="25bdz93yfembc">
                <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-petrol" data-id="element-175" data-mp="1qhrfqpbkxus8" /> Paiement Sécurisé
              </li>
              <li className="flex items-center gap-1.5" data-id="element-176" data-mp="1vft0deonm25t">
                <BoltIcon aria-hidden="true" className="h-3.5 w-3.5 text-petrol" data-id="element-177" data-mp="2j4vggi3n3my7" /> Accès Immédiat
              </li>
              <li className="flex items-center gap-1.5" data-id="element-178" data-mp="2o2wz51x5lk95">
                <CreditCardIcon aria-hidden="true" className="h-3.5 w-3.5 text-petrol" data-id="element-179" data-mp="29flmsxt5dw7z" /> Carte ·
                Google Pay · Apple Pay
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}